let VIEWS = {
  totp: 'App',
  sms: 'Sms',
  email: 'Email',
}

export function getView(value) {
  return VIEWS[value] || 'No'
}
